var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'bottom-sheet': _vm.bottomsheet, 'fixed-sheet': !_vm.bottomsheet
  }},[_vm._t("background"),_c('div',{ref:"sheet",staticClass:"drawer bg-white"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.bottomsheet),expression:"bottomsheet"}],staticClass:"dragbar"}),_vm._t("default")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }